import script from "./AboutUsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUsPage.vue?vue&type=script&setup=true&lang=js"

import "./AboutUsPage.vue?vue&type=style&index=0&id=5c8ea33c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c8ea33c"]])

export default __exports__